import { not } from '../util/not';
import { filter } from '../operators/filter';
import { from } from './from';
export function partition(source, predicate, thisArg) {
    return [filter(predicate, thisArg)(from(source)), filter(not(predicate, thisArg))(from(source))];
}
//# sourceMappingURL=partition.js.map